<template>
    <transition appear enter-active-class="animated fadeIn">
        <destinology v-if="destinology"/>
    </transition>
</template>

<script>
    import Destinology from '../components/affiliates/Destinology';
    //import Destinology from '../components/affiliates/Electus';
    import { mapActions, mapGetters } from "vuex";

    export default {
        name: "Affiliates",
        components: {
            Destinology,
        },
        data() {
            return {
                destinology: false
            }
        },
        methods: {
            ...mapActions({
                setAffiliation: 'setAffiliation',
            })
        },
        computed: {
            ...mapGetters({
                affiliation: 'affiliation',
            })
        },
        created() {
            if (this.$route.params.affiliate !== "") {
                this.setAffiliation(this.$route.params.affiliate);
            }

            if (this.$route.params.affiliate === "destinology") {
                this.destinology = true;
            }else{
                this.$router.push({name: 'pageNotFound'})
            }
        }
    }
</script>